/* global _, $, PubSub, require */

var App = (function (App, _) {
  'use strict';

  var moduleList = {},
    appBaseUrl = '/bundles/common/js/SdZ',
    preferences = {
      modules: {},
      paths: {
        appBase: appBaseUrl,
        lib: appBaseUrl + '/lib',
        widgets: appBaseUrl + '/widgets',
      },

      packages_url: {
        tinymce: '/legacy/js/tinymce.js',
      },

      modulesConfig: {
        map: {
          underscore: window._,
          jquery: window.jQuery,
        },

        autoInstantiate: {},
      },
    },
    moduleMethods;

  // get preferences set before
  if (App.preferences) {
    preferences = $.extend(true, preferences, App.preferences);
  }

  moduleMethods = {
    get: function (id) {
      return moduleList[id];
    },

    isInit: function (id) {
      var instance = this.getInstance(id),
        ret = false;

      if (instance) {
        ret = instance._isInit;
      }

      return ret;
    },

    deleteAllInstances: function () {
      var self = this;
      Object.keys(moduleList).forEach(function (id) {
        self.deleteInstance(id);
      });
    },

    deleteInstance: function (ids) {
      if (!$.isArray(ids)) {
        ids = [ids];
      }

      ids.forEach(function (id) {
        if (moduleList[id]) {
          delete moduleList[id].instance;
        }
      });
    },

    hasInstance: function (id) {
      return moduleList[id] ? !!moduleList[id].instance : false;
    },

    getInstance: function (id) {
      var instance = moduleList[id] && moduleList[id].instance ? moduleList[id].instance : null,
        dependencies = [];

      if (!instance && moduleList[id]) {
        if (moduleList[id].dependencies) {
          dependencies = moduleList[id].dependencies.map(function (dep) {
            var ret;
            if (window[dep] && dep !== 'require') {
              ret = window[dep];
            } else {
              ret = App.modules.require(dep);
            }

            return ret;
          });
        }

        instance =
          typeof moduleList[id].factory === 'function'
            ? moduleList[id].factory.apply(this, dependencies)
            : moduleList[id].factory;

        moduleList[id].instance = instance;
        // App.log('module instance created: ' + id);
      }

      return instance;
    },

    // define(id, dependencies, moduleConstructor)
    // define(id, moduleConstructor)
    define: function (id, dependencies, factory) {
      if (arguments.length === 2) {
        factory = dependencies;
        dependencies = null;
      }

      moduleList[id] = {
        factory: factory,
        dependencies: dependencies || [],
      };

      if (preferences.modulesConfig.autoInstantiate[id]) {
        moduleMethods.getInstance(id);
      }

      // App.log('module defined: ' + id);
    },

    require: function (id) {
      var ret;

      // TODO: remove that once we get ride of SyntaxHighlighter OR our AMD loader is more robust :)
      if (id.match(/sh[A-D].*/)) {
        return { SyntaxHighlighter: window.SyntaxHighlighter || null };
      }

      ret =
        preferences.modulesConfig.map[id] ||
        (id !== 'require' && window[id]) ||
        moduleMethods.getInstance(id);

      if (!ret) {
        // in webapp context, some custom jquery widget can be loaded and raise errors,
        // even if not used on the page. Prevent error by providing a fake baseWidget
        if (id === 'widgets/baseWidget') {
          const fooBaseWidget = function () {};
          fooBaseWidget._childConstructors = [];
          return fooBaseWidget;
        }
        App.log('undefined module required: ' + id);
      }

      return ret;
    },

    start: function (id) {
      var module = moduleList[id],
        pref = preferences.modules[id] || {};

      if (pref.disabled !== true) {
        if (module.instance) {
          module.instance.preferences = $.extend(
            {},
            module.instance.defaultPreferences || {},
            pref
          );

          if (typeof module.instance.init === 'function' && !module.instance._isInit) {
            try {
              module.instance.init();
              module.instance._isInit = true;

              // App.log('module start: ' + id);
            } catch (e) {
              if (App.preferences.debug) {
                window.console.log(e.stack);
                throw e;
              }
            }
          }
        }
      }
    },

    startAll: function () {
      var self = this;

      $.each(moduleList, function (id) {
        var instance = moduleMethods.getInstance(id);
        if (instance && instance.init) {
          self.start(id);
        }
      });
    },

    launch: function (name) {
      const instance = moduleMethods.getInstance(name);
      if (instance && instance.init) {
        this.start(name);
      }
    },
  };

  $.extend(App, {
    // alias to PubSub
    events: typeof PubSub !== 'undefined' ? PubSub : {},

    /* istanbul ignore next */
    log: function (/* args */) {
      if (App.preferences.debug && typeof window.console !== 'undefined' && window.console.log) {
        if (window.console.log.apply) {
          window.console.log.apply(window.console, arguments);
        } else {
          window.console.log(arguments[0]);
        }
      }
    },

    /* istanbul ignore next */
    warn: function (/* args */) {
      if (App.preferences.debug && typeof window.console !== 'undefined' && window.console.warn) {
        if (window.console.log.apply) {
          window.console.warn.apply(window.console, arguments);
        } else {
          window.console.log(arguments[0]);
        }
      }
    },

    string: {
      // string is first param, then list of values
      // ie: App.string.format("you got {0} message(s)", 6);
      format: function () {
        var values = Array.prototype.slice.call(arguments, 1);

        return arguments[0].replace(/\{(\d+)\}/g, function (e, i) {
          return values[i];
        });
      },
    },

    // basic internationalisation :)
    i18n: function () {
      if (App._i18n && App._i18n['fr_FR']) {
        arguments[0] = App._i18n['fr_FR'][arguments[0]] || arguments[0];
      }

      return App.string.format.apply(this, arguments);
    },

    modules: moduleMethods,

    getPreferences: function () {
      return preferences;
    },

    setPreferences: function (newpreferences) {
      preferences = newpreferences;
    },
  });

  return App;
})(window.App || {}, _);

App.modules.define('app/core', App);
App.modules.define('i18n', function () {
  return App.i18n;
});
App.modules.define('utils/string', function () {
  return App.string;
});
App.modules.define('require', function () {
  return App.modules.require;
});

window.App = App;

// expose that globally
window.define = App.modules.define;
window._define = App.modules.define;
window.template = _.template;

// this fix is for IE only, move it in a dedicated file if we need more fix like that
/* istanbul ignore next */
if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
}
